import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getUserDocumentsService(params = {}) {
  const { userId, page = 0, limit = 25, ...extra } = params;

  const id = userId || new Storage("id").getItem();
  const url = URL.setParams(URL.buildUrl(`users/${id}/documents`), {
    page,
    limit,
    ...extra,
  });

  return await new API(url).get();
}

export async function getDocumentByIdService(documentId) {
  const url = URL.setId(URL.buildUrl("documents"), documentId);
  return await new API(url).get();
}

export async function getDocumentsByUserService(params = {}) {
  const {
    userId,
    page = 0,
    limit = 25,
    projectId,
    field_sort = "date",
    sort = "descending",
    ...extra
  } = params;

  const id = userId || new Storage("id").getItem();

  // Build the query parameters
  const queryParams = { page, limit, field_sort, sort, ...extra };

  // Add the filter parameter only if projectId is provided
  if (projectId) {
    queryParams.filter = { ids: [projectId] }; // Pass filter as a plain object
  }

  const url = URL.setParams(URL.buildUrl(`users/${id}/documents`), queryParams);

  console.log("Final URL in getDocumentsByUserService:", url);
  return await new API(url).get();
}
export async function postDocumentByProjectService({
  id,
  type,
  description,
  file,
}) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);
  formData.append("description", description);
  formData.append("projectId", id);

  const url = URL.setId(URL.buildUrl("documents"));
  return await new API(url).post(formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
